<template>
    <BaseModal v-if="isOpen" @modalState="close">
        <template #content>
            <div class="modal-campaign-accepted">
                <img :src="SuccessCircle" alt="Imagem de sucesso no aceite da campanha">
                <div class="modal-texts">
                    <h1>Uhuul, você está participando da campanha!</h1>
                </div>
                <button class="button is-primary" @click="close">Ok, entendi</button>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'
import SuccessCircle from '@/assets/img/campaigns/tax-back/success-circle.png'

export default {
    name: 'ModalWalletBonusCampaign',

    components: {
        BaseModal,
    },

    props: {
        isOpen: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            SuccessCircle
        }
    },

    methods: {
        close() {
            this.$emit('close')
        }
    },
}
</script>

<style lang="scss" scoped>
:deep(.c-base-modal__wrapper) {
    max-width: 520px;
    border-radius: 8px;
}

.modal-campaign-accepted {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    padding: 36px 24px 24px 24px;

    .modal-texts {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        text-align: center;

        h1 {
            color: #323C48;
            font-size: 20px;
            font-weight: 700;
            line-height: 28px;
        }
    }

    button {
        border-radius: 100px;
        padding: 16px 24px;
    }
}

@media (max-width: 800px) {
    :deep(.c-base-modal__wrapper) {
        max-width: 420px;
    }

    .modal-campaign-accepted {
        height: 450px;
        max-width: 420px;

        .modal-texts {
            align-items: center;
        }

        button {
            width: fit-content;
        }
    }
}
</style>